module.exports = __webpack_public_path__ + "media/images/icons/map/marker-bus-sad-e0459128c2632f640133441f95f92453.png";